import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CuentasRecaudoService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  getCuentasRecaudo(){
    return this.http.get(`${this.baserApiUrl}cuentas-recaudo?options=0`)
  }
}
